import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Box,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  djangoHandleDataRequests,
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../api";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "material-react-toastify";
import { connect } from "react-redux";

const AddUpdateSpace = ({
  selectedRental,
  allRentals,
  setOpenAddEditSpace,
  data,
}) => {
  const zeroTax = [
    {
      id: 0,
      is_group_tax: "false",
      name: "Tax",
      percentage: 0,
      province: "India",
    },
  ];
  const [existingRentals, setExistingRentals] = useState(
    allRentals
      ?.filter((item) => item?.status === "ACTIVE")
      .map((item) => item?.globalNonRentalTypeId) || []
  );

  const [globalRentals, setGlobalRentals] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: {},
    perHourCost: 0,
    perHourTaxId: zeroTax[0],
    perPersonCost: 0,
    perPersonTaxId: zeroTax[0],
  });
  const [loading, setLoading] = useState(false);

  const [taxes, setTaxes] = useState([]);
  useEffect(() => {
    setExistingRentals(
      allRentals
        ?.filter((item) => item?.status === "ACTIVE")
        .map((item) => item?.globalNonRentalTypeId) || []
    );
  }, [allRentals]);

  useEffect(() => {
    if (selectedRental?.name) {
      setFormData({
        name: selectedRental?.name || "",
        description: selectedRental?.description || "",
        type: selectedRental?.type
          ? globalRentals?.filter(
              (item) => item?.id === selectedRental?.globalNonRentalTypeId
            )?.[0]
          : globalRentals?.[0],
        perHourCost: selectedRental?.perHourCost || 0,
        perHourTaxId:
          selectedRental?.taxId > -1
            ? taxes?.filter((item) => item?.id === selectedRental?.taxId)?.[0]
            : selectedRental?.groupTaxId > -1
            ? taxes?.filter(
                (item) => item?.id === selectedRental?.groupTaxId
              )?.[0]
            : zeroTax[0],
        perPersonCost: selectedRental?.perPersonCost || 0,
        perPersonTaxId:
          selectedRental?.personTaxId > -1
            ? taxes?.filter(
                (item) => item?.id === selectedRental?.personTaxId
              )?.[0]
            : selectedRental?.personGroupTaxId > -1
            ? taxes?.filter(
                (item) => item?.id === selectedRental?.personGroupTaxId
              )?.[0]
            : zeroTax[0],
      });
    }
  }, [selectedRental, globalRentals, taxes]);

  const getAllTaxes = async () => {
    try {
      const [taxes, groupTaxes] = await Promise.all([
        djangoHandleDataRequests("tax/getAllTaxCategories"),
        djangoHandleDataRequests("grouptax/getAllGroupTaxCategories"),
      ]);

      const formattedGrpTaxes = groupTaxes.map((grpTax) => ({
        id: grpTax?.id,
        name: grpTax?.name,
        province: "India",
        percentage: (grpTax?.tax_components || [])?.reduce((acc, curr) => {
          return acc + (curr?.tax_percentage || 0);
        }, 0),
        is_group_tax: "true",
      }));

      const allTaxes = [...zeroTax, ...taxes, ...formattedGrpTaxes];
      setTaxes(allTaxes);
    } catch {
      toast.error("Error in fetching the taxes. Contact the support team.");
    }
  };
  useEffect(() => {
    getAllTaxes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "perHourCost" || name === "perPersonCost") {
      /^[0-9.-]*$/.test(value) &&
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    handleSpringDataRequest(`core/api/v1/non-rental/get-global-non-rental`)
      .then((res) => {
        setGlobalRentals(res);
      })
      .catch(() => {});
  }, []);

  const handleAddUpdateSpace = () => {
    if (!formData.name?.trim() || !formData.type?.id) {
      toast.error("Please fill all the required fields.");
      return;
    }

    const payload = {
      id: selectedRental?.id || null,
      globalNonRentalTypeId: formData?.type?.id,
      hotelId: data?.hotelId,
      name: formData?.name,
      description: formData?.description,
      type: formData?.type?.name,
      perHourCost: formData?.perHourCost,
      taxId:
        formData?.perHourTaxId?.is_group_tax === "false"
          ? formData?.perHourTaxId?.id
          : null,
      groupTaxId:
        formData?.perHourTaxId?.is_group_tax === "true"
          ? formData?.perHourTaxId?.id
          : null,
      perPersonCost: formData?.perPersonCost,
      personTaxId:
        formData?.perPersonTaxId?.is_group_tax === "false"
          ? formData?.perPersonTaxId?.id
          : null,
      personGroupTaxId:
        formData?.perPersonTaxId?.is_group_tax === "true"
          ? formData?.perPersonTaxId?.id
          : null,
    };
    setLoading(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental/create-update-non-rental-type`,
      payload
    )
      .then((res) => toast.success(res))
      .catch(() => toast.error("Error in adding/updating space."))
      .finally(() => {
        setOpenAddEditSpace(false);
        setLoading(false);
      });
  };

  return (
    <Box sx={{ paddingX: 2, maxWidth: 600, margin: "0 auto" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingY: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          {selectedRental.id ? "Update Space" : "Add New Space"}
        </Typography>
        <IconButton onClick={() => setOpenAddEditSpace(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label="Type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            fullWidth
            required
          >
            {globalRentals
              ?.filter(
                (item) =>
                  !existingRentals?.includes(item?.id) ||
                  selectedRental?.globalNonRentalTypeId === item?.id
              )
              ?.map((item) => (
                <MenuItem value={item}>{item?.name}</MenuItem>
              ))}
          </TextField>
        </Grid>

        {/* <Grid item xs={4}>
          <TextField
            label="Per Hour Cost"
            name="perHourCost"
            value={formData.perHourCost}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid> */}

        {/* <Grid item xs={8}>
          <TextField
            select
            label="Per Hour Tax"
            name="perHourTaxId"
            value={formData.perHourTaxId}
            onChange={handleChange}
            fullWidth
          >
            {taxes.map((item, index) => (
              <MenuItem id={index} value={item}>
                {item.name}&nbsp;[{item.percentage} %] &nbsp;
                {String(item.is_group_tax) === "true" && (
                  <i style={{ fontSize: "10px" }}>(Group tax)</i>
                )}
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}

        {/* <Grid item xs={4}>
          <TextField
            label="Per Person Cost"
            name="perPersonCost"
            value={formData.perPersonCost}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid> */}

        {/* <Grid item xs={8}>
          <TextField
            select
            label="Per Person Tax"
            name="perPersonTaxId"
            value={formData.perPersonTaxId}
            onChange={handleChange}
            fullWidth
          >
            {taxes.map((item, index) => (
              <MenuItem id={index} value={item}>
                {item.name}&nbsp;[{item.percentage} %] &nbsp;
                {String(item.is_group_tax) === "true" && (
                  <i style={{ fontSize: "10px" }}>(Group tax)</i>
                )}
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}

        <Grid item xs={12}>
          <Button
            variant="custom-button"
            color="primary"
            fullWidth
            onClick={handleAddUpdateSpace}
            disabled={loading}
          >
            {selectedRental.id ? "Update" : "Add"}{" "}
            {loading && (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            )}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(AddUpdateSpace);
